import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './gameButton.css';
import './ic_play.png';


export default class GameButton extends Component {

  render() {
    return (
      <button 
        id={this.props.id}
        className={`game-button ${this.props.customClass}`} 
        disabled={this.props.disabled} 
        onClick={this.props.clickHandler}>{this.props.text}</button>
    );
  }
}

GameButton.propTypes = {
  id: PropTypes.string, 
  text: PropTypes.string, 
  customClass: PropTypes.string, 
  disabled: PropTypes.bool, 
  clickHandler: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/game-button/gameButton.js